<template>
	<section id="marker-summary-history-tab" class="container-fluid mb-5 step-content">
		<div class="row mb-4">
			<div class="col-12 d-flex align-items-center justify-content-between">
				<h2 class="title mr-3">
					<font-awesome-icon :icon="['fas', 'history']" />
					History
				</h2>
			</div>
		</div>

		<el-tabs type="card" tab-position="left">
			<el-tab-pane label="Event History">
				<history-event></history-event>
			</el-tab-pane>
			<el-tab-pane label="Notification History">
                <history-notification></history-notification>
            </el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>

    import HistoryEvent from '@ambition/components/application-steps/HistoryEvent'
    import HistoryNotification from '@ambition/components/application-steps/HistoryNotification'

	export default {
		name: "History",
        components: {
            HistoryEvent,
            HistoryNotification
        },
		data() {
			return {

			}
		},
		computed: {

		},
		mounted() {

		},
		methods: {

		},
	}
</script>

<style lang="scss" scoped>
    .el-tabs {
        &__header {
            margin: 0 !important;
        }

        &__nav {
            border: none !important;
        }

        &__item {
            border: 1px solid #c2cfd6 !important;
            &.is-active {
                background: #f0f3f5 !important;
                border-right-color: #f0f3f5 !important;
            }
        }
    }
</style>
